<div>
  <ng-template appUploadDialog></ng-template>
</div>
